const carouselItems = [
  {
    id: 1,
    title: '日剧精选：今夏必看的十部高分神作',
    desc: '从治愈系到悬疑烧脑，这个夏天日剧迷们有福了。我们精选了十部豆瓣评分8.5以上的口碑佳作。',
    img: 'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20Japanese%20drama%20posters%20arranged%20artistically%20on%20a%20warm%20wooden%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20Japanese%20aesthetic%20with%20cherry%20blossom%20accents%2C%20cinematic%20mood%2C%20elegant%20composition&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '编辑精选',
  },
  {
    id: 2,
    title: '国产剧崛起：年度口碑剧集大盘点',
    desc: '近年来国产剧质量飞速提升，从古装权谋到都市情感，好剧层出不穷。我们为你盘点年度最值得看的国产剧。',
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20Chinese%20historical%20drama%20scenes%20with%20traditional%20costumes%20and%20ancient%20architecture%2C%20warm%20golden%20lighting%2C%20epic%20cinematic%20composition%2C%20rich%20cultural%20atmosphere%2C%20dramatic%20and%20elegant%20visual%20style&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '年度推荐',
  },
  {
    id: 3,
    title: '欧美大片专题：科幻与动作的双重盛宴',
    desc: '好莱坞最新大片一站看齐。从星际冒险到街头追逐，肾上腺素飙升的观影体验，尽在樱花TV。',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Hollywood%20action%20movie%20scene%20collage%20with%20explosive%20visual%20effects%2C%20futuristic%20cityscape%20and%20space%20battle%20elements%2C%20dramatic%20lighting%20with%20orange%20and%20teal%20color%20grading%2C%20cinematic%20blockbuster%20aesthetic&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '热门专题',
  },
  {
    id: 4,
    title: '悬疑烧脑特辑：挑战你的推理能力',
    desc: '精选全球高分悬疑剧集与电影，每一个细节都可能是破案关键。准备好你的大脑，一场智力较量即将开始。',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20crime%20scene%20with%20a%20magnifying%20glass%20over%20clues%20and%20evidence%2C%20dark%20atmosphere%20with%20dramatic%20shadows%2C%20film%20noir%20aesthetic%2C%20vintage%20detective%20office%20with%20warm%20lamp%20light%2C%20intriguing%20and%20suspenseful%20composition&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '专题策划',
  },
  {
    id: 5,
    title: '治愈系影视：温暖你的一整天',
    desc: '忙碌的生活需要一些温柔的力量。这些治愈系作品如春风拂面，抚慰心灵，让你在屏幕前找到片刻宁静。',
    img: 'https://readdy.ai/api/search-image?query=A%20cozy%20and%20warm%20living%20room%20scene%20with%20soft%20blankets%20and%20warm%20lighting%2C%20a%20television%20screen%20showing%20a%20peaceful%20countryside%20scene%2C%20comforting%20atmosphere%2C%20gentle%20sunlight%20through%20curtains%2C%20relaxing%20and%20healing%20mood&width=800&height=450&seq=carousel-05&orientation=landscape',
    tag: '治愈推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              焦点专题
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              深度策划，发现更多好内容
            </p>
          </div>

          <div className="flex flex-col gap-6">
            {carouselItems.map((item) => (
              <a
                key={item.id}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="group flex flex-col md:flex-row gap-5 bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-full md:w-[360px] shrink-0 aspect-video md:aspect-auto overflow-hidden bg-background-100">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <span className="inline-block self-start px-2 py-0.5 text-xs font-medium rounded bg-accent-100 text-accent-800 whitespace-nowrap mb-3">
                    {item.tag}
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-primary-500 whitespace-nowrap">
                    查看详情 <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}